require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./member-rheanne-odessa-jimeno.json") })
        }
      }, "path---member-rheanne-odessa-jimeno");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---member-rheanne-odessa-jimeno!./.cache/json/member-rheanne-odessa-jimeno.json
// module id = 408
// module chunks = 231608221292675